import { SLOTS, SLOT_COUNT, emptyDay } from './slots.js';

// Helper: find slot index by hour+minute
function si(h, m = 0) {
  return SLOTS.findIndex(s => s.h === h && s.m === m);
}

function fill(track, fromH, fromM, toH, toM, cat) {
  const start = si(fromH, fromM);
  let endIdx;
  if (toM === 0 && toH > 0) endIdx = si(toH, 0);
  else endIdx = si(toH, toM);
  if (endIdx === -1) endIdx = SLOT_COUNT;
  for (let i = start; i < endIdx; i++) track[i] = cat;
}

function buildSampleData() {
  // ---- 4-15 ----
  const d15 = emptyDay('2026-04-15');
  d15.meals = { breakfast: 'ontime', lunch: 'ontime', dinner: 'ontime' };
  d15.sleepDuration = '6-9h';
  d15.boneMass = 1.8;
  d15.weight = 46.3;
  d15.mainEvent = '喜马拉雅的打卡苹卡天经不及待，要也害';
  d15.emotions = ['平稳'];
  d15.efficiency = '高效';
  d15.nightWake = 0;
  fill(d15.tracks[1], 0, 0, 7, 0, 'sleep');
  fill(d15.tracks[1], 23, 0, 24, 0, 'sleep');
  fill(d15.tracks[0], 7, 0, 7, 30, 'prep_xnx');
  fill(d15.tracks[0], 7, 30, 8, 0, 'eat');
  fill(d15.tracks[2], 7, 30, 8, 0, 'exercise');
  fill(d15.tracks[0], 8, 0, 9, 0, 'prep_xnx');
  fill(d15.tracks[0], 9, 0, 12, 0, 'focus');
  fill(d15.tracks[0], 12, 0, 13, 0, 'eat');
  fill(d15.tracks[1], 13, 0, 14, 0, 'sleep');
  fill(d15.tracks[0], 14, 0, 17, 0, 'focus');
  fill(d15.tracks[0], 17, 0, 18, 0, 'eat');
  fill(d15.tracks[0], 18, 0, 20, 0, 'fun');
  fill(d15.tracks[2], 20, 0, 21, 0, 'exercise');
  fill(d15.tracks[0], 21, 0, 22, 0, 'prep_pr');
  fill(d15.tracks[0], 22, 0, 23, 0, 'focus');
  d15.notes[`0:${si(18)}`] = '《东极岛》';
  d15.notes[`0:${si(9)}`] = '萌主logo';
  d15.notes[`0:${si(16)}`] = '复盘表备份到语雀';

  // ---- 4-16 ----
  const d16 = emptyDay('2026-04-16');
  d16.meals = { breakfast: 'ontime', lunch: 'ontime', dinner: 'ontime' };
  d16.sleepDuration = '3-6h';
  d16.boneMass = 1.8;
  d16.weight = 46.3;
  d16.mainEvent = '快清';
  d16.emotions = ['焦虑'];
  d16.efficiency = '一般';
  d16.nightWake = 1;
  fill(d16.tracks[1], 0, 0, 6, 0, 'sleep');
  fill(d16.tracks[1], 23, 0, 24, 0, 'sleep');
  fill(d16.tracks[0], 6, 0, 8, 0, 'prep_pr');
  fill(d16.tracks[0], 8, 0, 9, 0, 'eat');
  fill(d16.tracks[0], 9, 0, 12, 0, 'focus');
  fill(d16.tracks[0], 12, 0, 13, 0, 'eat');
  fill(d16.tracks[1], 13, 0, 14, 0, 'sleep');
  fill(d16.tracks[0], 14, 0, 17, 0, 'focus');
  fill(d16.tracks[0], 17, 0, 18, 0, 'eat');
  fill(d16.tracks[0], 18, 0, 20, 0, 'fun');
  fill(d16.tracks[0], 20, 0, 22, 0, 'prep_pr');
  fill(d16.tracks[0], 22, 0, 23, 0, 'focus');
  d16.notes[`0:${si(8)}`] = '玩Q宠赖床';
  d16.notes[`0:${si(18)}`] = '《东极岛》';

  // ---- 4-17 ----
  const d17 = emptyDay('2026-04-17');
  d17.meals = { breakfast: 'ontime', lunch: 'late', dinner: 'late' };
  d17.sleepDuration = '3-6h';
  d17.boneMass = 1.7;
  d17.weight = 45.8;
  d17.mainEvent = '快和分类、留时间应应';
  d17.emotions = ['内耗', '压抑'];
  d17.efficiency = '低能量';
  d17.nightWake = 2;
  d17.phoneBeforeSleep = true;
  fill(d17.tracks[1], 0, 0, 7, 0, 'sleep');
  fill(d17.tracks[1], 23, 0, 24, 0, 'sleep');
  fill(d17.tracks[0], 7, 0, 9, 0, 'fun');
  fill(d17.tracks[0], 9, 0, 12, 0, 'prep_pr');
  fill(d17.tracks[0], 12, 0, 13, 0, 'eat');
  fill(d17.tracks[1], 13, 0, 15, 0, 'sleep');
  fill(d17.tracks[0], 15, 0, 18, 0, 'fun');
  fill(d17.tracks[0], 18, 0, 19, 0, 'eat');
  fill(d17.tracks[0], 19, 0, 22, 0, 'fun');
  fill(d17.tracks[0], 22, 0, 23, 0, 'prep_pr');
  d17.notes[`0:${si(9)}`] = '《献王虫鱼》下';
  d17.notes[`0:${si(15)}`] = '《城市设计》';
  d17.notes[`0:${si(20)}`] = 'forest';

  // ---- 4-18 ----
  const d18 = emptyDay('2026-04-18');
  d18.meals = { breakfast: 'late', lunch: 'ontime', dinner: 'ontime' };
  d18.sleepDuration = '6-9h';
  d18.boneMass = 1.8;
  d18.weight = 46.4;
  d18.mainEvent = '半夜被狗吗听';
  d18.emotions = ['平稳'];
  d18.efficiency = '高效';
  d18.nightWake = 0;
  fill(d18.tracks[1], 0, 0, 9, 0, 'sleep');
  fill(d18.tracks[1], 23, 0, 24, 0, 'sleep');
  fill(d18.tracks[0], 9, 0, 10, 0, 'eat');
  fill(d18.tracks[0], 10, 0, 12, 0, 'prep_xnx');
  fill(d18.tracks[0], 12, 0, 13, 0, 'eat');
  fill(d18.tracks[2], 12, 0, 13, 30, 'exercise');
  fill(d18.tracks[0], 13, 30, 15, 0, 'focus');
  fill(d18.tracks[0], 15, 0, 17, 0, 'focus');
  fill(d18.tracks[2], 16, 0, 18, 0, 'exercise');
  fill(d18.tracks[0], 17, 0, 18, 0, 'eat');
  fill(d18.tracks[0], 18, 0, 20, 0, 'fun');
  fill(d18.tracks[0], 20, 0, 22, 0, 'prep_pr');
  fill(d18.tracks[0], 22, 0, 23, 0, 'focus');
  d18.notes[`0:${si(9)}`] = '奶粉+肉松小贝';
  d18.notes[`0:${si(12)}`] = '寿司';
  d18.notes[`0:${si(18)}`] = '《和嗦哪去公园》';

  return {
    '2026-04-15': d15,
    '2026-04-16': d16,
    '2026-04-17': d17,
    '2026-04-18': d18,
  };
}

export const SAMPLE_DATA = buildSampleData();
